// src/mocks/handlers/auth/tokenHandler.ts

import { rest } from 'msw';
import users from '@/mocks/data/users.json';
import { tokenSchema } from './authHandlers.schema';
import {
  TokenRequestBody,
  TokenResponse,
  ErrorResponse,
} from '@/domains/auth/auth.types';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { resetTokenTimers } from '@/mocks/data/tokenTimers';

export const tokenHandler = rest.post<
  TokenRequestBody,
  TokenResponse | ErrorResponse
>(`${VITE_MSW_BASE_URL}${API_ENDPOINTS.AUTH_TOKEN}`, (req, res, ctx) => {
  const parsedBody = tokenSchema.safeParse(req.body);

  if (!parsedBody.success) {
    return res(
      ctx.status(400),
      ctx.json({
        error: 'Invalid request data',
        issues: parsedBody.error.issues,
      }),
    );
  }

  const { email, password, otp } = parsedBody.data;
  const user = users.find(
    (u) => u.email === email && u.password === password && u.otp === otp,
  );

  if (user) {
    resetTokenTimers();

    return res(
      ctx.status(200),
      ctx.json({
        access_token: 'mock_access_token',
        refresh_token: 'mock_refresh_token',
      }),
    );
  }

  return res(ctx.status(401), ctx.json({ error: 'Invalid credentials' }));
});
